module.exports = __webpack_public_path__ + "img/atome.2622b3c1.png";